module.exports = __webpack_public_path__ + "img/p2.e6abdce3.png";